<template>
  <div>
    <common-dialog
      ref="dialog"
      width="300px"
      center
      title="导入 请假信息"
      :confirm-on-close-change="false"
    >
      <template slot="form">
        <div style="text-align: center;margin-bottom: 30px;">
          <span style="margin-bottom: 10px;display: inline-block;">学期：{{TermName}}</span>
          <div style="margin-top: 15px;">
            <import-file :upload-url="url" text="导入请假信息" w="150px" @on-uploaded="uploaded" />
          </div>
          <div style="margin-top: 30px;">
            <el-button size="mini" style="width: 150px;" plain @click="download">下载信息模板</el-button>
          </div>
          <div style="margin-top: 30px;" v-if="detailUrl">
            <el-button size="mini" style="width: 150px;" type="danger" plain @click="detail">下载错误明细</el-button>
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
  },
  data() {
    return {
      api: require("@/api/st/leave").default,
      attach: require("@/api/common/attach").default,
      detailUrl: "",
      TermId: null,
      TermName: "",
    };
  },
  computed: {
    url() {
      return this.api.import + "?TermId=" + this.TermId;
    },
  },
  methods: {
    setData(data) {
      console.log("set", data);
      this.TermId = data.TermId;
      this.TermName = data.TermName;
    },
    download() {
      var url = "/Template/请假导入模板.xlsx";
      this.attach.downloadByUrl(url, "请假导入模板.xlsx");
    },
    detail() {
      this.attach.downloadByUrl(this.detailUrl, "错误明细.xlsx");
    },
    uploaded(res) {
      console.log("uploaded", res);
      if (res.Code != 0) {
        if (res.Code == 2) {
          this.detailUrl = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      } else {
        this.$emit("upload-success");
        this.close(true);
        this.detailUrl = "";
      }
    },
  },
};
</script>
<style lang="scss">
</style>